import React from "react";

const ClientProtectionContentTwo = () => {
  const securityFeatures = [
    {
      title: "Advanced Account Security",
      text: "Your account is safeguarded with strong authentication tools, including secure passwords and optional 2FA. Session monitoring and device recognition ensure only you can access and manage your activity.",
    },
    {
      title: "Encrypted Data Transmission",
      text: "All data between your device and our servers is protected with banking-grade encryption. This keeps your personal information, transactions, and orders secure across all platforms.",
    },
    {
      title: "Real-Time Threat Detection",
      text: "Our systems constantly analyze activity to detect suspicious behavior or unauthorized attempts. Automated protective responses activate instantly to keep your account and funds safe.",
    },
    {
      title: "Secure Payment & Withdrawal Verification",
      text: "Every deposit and withdrawal undergoes strict identity and transaction verification. This ensures your funds move securely and only with your authorization.",
    },
    {
      title: "Continuous System Audits & Compliance",
      text: "We follow global financial security standards and conduct ongoing audits to maintain platform integrity. Regular updates and compliance checks ensure strong protection against evolving risks.",
    },
  ];

  return (
    <div className="sm-security-section">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE: Main Heading */}
          <div className="col-lg-4 col-md-12 col-12">
            <div className="sm-content-left">
              <h2 className="sm-main-title">
                Protection at Every Level of Your Trading Experience
              </h2>
            </div>
          </div>

          {/* RIGHT SIDE: Intro Text + Feature List */}
          <div className="col-lg-8 col-md-12 col-12">
            <div className="sm-content-right">
              <p className="sm-intro-text">
                Our platform is built with layered security, real-time
                monitoring, and industry-standard safeguards, so you can trade
                with confidence from the moment you log in.
              </p>

              <div className="sm-feature-list">
                {securityFeatures.map((item, index) => (
                  <div key={index} className="sm-feature-item">
                    <div className="sm-feature-row">
                      <div className="sm-feature-title">
                        <h3>{item.title}</h3>
                      </div>
                      <div className="sm-feature-desc">
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientProtectionContentTwo;
